import { JsonPipe } from '@angular/common';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { ComponentFactoryResolver, Injectable, ViewChild } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { DomSanitizer } from '@angular/platform-browser';
import { catchError, Observable, Subject } from 'rxjs';
import { environment } from 'src/environments/environment';
// import { CategoryModel, favreportsModel, mapingFactModel, newreports, notificationModel, rcvreportsModel, roletypeModel, trendingreports, worbookModel, wtlreportsModel } from '../sm-models/Category_folder';
import * as CryptoJS from 'crypto-js';
export const httpGetOptions = {
  headers: new HttpHeaders({
    'Access-Control-Allow-Origin':'*',
  })
};

const httpOptions = {
  headers: new HttpHeaders({
      'Content-Type':  'application/json'

      // ,'Access-Control-Allow-Origin': '*',
  })
};

@Injectable({
  providedIn: 'root'
})

export class ApiService {

  constructor(private httpClient: HttpClient, private sanitizer: DomSanitizer) { }
  isShowDiv = false;
  cat_table: boolean = false
  fav: boolean = false;
  rcv: boolean = false;
  wtl: boolean = false;
  newcat:boolean=false;
  indexNumber:number=0;
  site_id: string = ""; // stores site id when the user logs in and can be use globaly
  auth_token: string = ""; // stores auth_token when user logs in and can be used globaly
  toog = 0; //helps in togling between report and meta data
  gettotal = 0; //for the total records in folder
  workbook_index: number = 0;
  category_id: number = 0;
  imagePath: any;
  cw_id: number = 0; //this stores the workbook id of the database helps in rendirng the report data meta data
  sat_length: number = 0;
  wtl_length: number = 0;
  catid: any;
  id: number = 0;
  cwid: number = 0;
  cwname: string ='';
  preview: any;
  file: any;
  notificationpopup: string = "";
  UserList: any[] = [];
  filterList: any[] = [];
  notificationlistlength:any;
  notificationunseencount:number=0;
  notificationid: any;
  editdetails: any;
  usernotification:any;
adminnotification:any;
  // java content
  search_table: boolean = true;
  // mapingFact: mapingFactModel[] = [];// mapping fact content is stored
  catsortingarray:any;
  // parentcatrgoryname: mapingFactModel[] = []; // parent category data is stored
  // workbooksList: worbookModel[] = []; // maped workbook data is stored
  workbookdata:any;
  // categoryList: CategoryModel[] = []; // Totoal category list is stored
  // trendingList: trendingreports[] = []; // Trending reports ids are stored
  // newreportslist: newreports[] = []; // New reports id's are stored
  // favreports: favreportsModel[] = [];
  favsortingarray:any;
  // favreports1:favreportsModel[] = [];// favourite report id's are stored
  sortwtlreports:any;
  // wtlreports: wtlreportsModel[] = []; // view later reports id's are stored
  // rcvreports: rcvreportsModel[] = []; // recently vied reports id's are stored
  sortrcvreports:any;
  // CustomReports: worbookModel[] = [];
  // ConfigReports: worbookModel[] = [];
  // roletypeModel:roletypeModel[]=[];
  mapingFactwb: any[] = [] // mapping fact workbooks content is stored
  workbook_images: any[] = []; // total workbook images are stored
  // unmappedworkbooks: worbookModel[] = []; // unmaped workbook list is stored
  curentuser: any = sessionStorage.getItem("currentUser"); // loged in user id is stored
  roletypeid: any = localStorage.getItem('roletypeid'); // logged in role id is stored
  rcvupdated: number = 0;
  wtlid: number = 0;
  workbooknamedata:any[]=[];

wtldate= (new Date()).toUTCString();

// trackworkbook(userid:number,wbid:number)
// {
//   console.log("userid is "+userid+"wbid is "+wbid)
//     this.httpClient.put(environment.JavaUrlEndPoint + "workbooktrack",{"userid":userid,"workbookid":wbid},{ responseType: 'text' as 'json' }).subscribe(
//       (data: any) => {

//       });
// }

// decryptionAES (msg) {
//   // Decrypt
//   const bytes  = CryptoJS.AES.decrypt(msg, 'secret key 123');
//   const plaintext = bytes.toString(CryptoJS.enc.Utf8);
//   return plaintext;
// }
loggedinuser:number;
  // getmapingFactData() {


//       this.httpClient.get(environment.JavaUrlEndPoint + "getcategories").subscribe(


//         (data: any) => {

//           // console.log(data)
//           data=[...data].sort((a,b)=>a.workbookname>b.workbookname?1:-1)
//           this.mapingFact = data;
//           this.catsortingarray=data;
//           this.getworbooksData();
//           this.getWorkbookdata();
//           // this.gettrendingreports();
//           // this.getnewreports();
//           this.getfavreports();
//           this.getrcvreports();
//           this.getwtlreports();

// //           const decrypted = this.decryptionAES(this.curentuser);
// //     const parsedData = JSON.parse(decrypted);
// // const id = parsedData.id;
// // this.loggedinuser=id;
// // console.log(id); // Output: 1

// //           console.log(decrypted)
//         }
//       );

  // }
//   getWorkbookdata() {


//     this.httpClient.get(environment.JavaUrlEndPoint + "getworkbooks").subscribe(


//       (data: any) => {

//         data=[...data].sort((a,b)=>a.workbookname>b.workbookname?1:-1);
//         this.workbooknamedata = data;
//         // setTimeout(()=>{

//         //   ($('#data_tabletoggle') as any).dataTable(
//         //     {

//         //       pagingType: 'full_numbers',
//         //       pageLength: 10,
//         //       lengthMenu: [10,20,30,40,50,60],
//         //       processing: true,
//         //       searching:true,
//         //       orderMultiple:true,
//         //       searchHighlight:true,
//         //       "bDestroy": true,


//         //     }
//         //   );
//         // }
//         // )

//       }
//     );

// }
// details:any[]
// editable_fields:any[]
// dataLinkId:number;
//   openreportttttt(workbookname:any)
//   {
//     // this.dataLinkId=0;
//     console.log(workbookname)

//     // this.dataLinkId=;
//     switch(workbookname)
//     {
//       case 'Birth Certificate ':this.dataLinkId=12;
//       console.log(this.dataLinkId)
//       break;

//       case 'AD Raw Data':this.dataLinkId=14;
//       console.log(workbookname);
//       console.log(this.dataLinkId)
//       break;

//       case 'Triage Assignments':this.dataLinkId=29;
//       console.log(this.dataLinkId)
//       break;

//       case'Confirmed Cases':this.dataLinkId=24;
//       console.log(this.dataLinkId)
//       break;

//       case'BD Abstraction': this.dataLinkId=32;
//       console.log(this.dataLinkId)
//       break;

//       case'BD Abstraction Raw' :this.dataLinkId=30;
//       console.log(this.dataLinkId)
//       break;

//       case'BC BD Report' :this.dataLinkId=21;
//       console.log(this.dataLinkId)
//       break;

//       case'Discharge BD':this.dataLinkId=20;
//       console.log(this.dataLinkId)
//       break;

//       case'Report by Hospital':this.dataLinkId=19;
//       console.log(this.dataLinkId)
//       break;

//       case'Prenatal Diagnosis' :this.dataLinkId=18;
//       console.log(this.dataLinkId)
//       break;

//       case'Hearing Screening Results':this.dataLinkId=1;
//       console.log(this.dataLinkId)
//       break;

//       case'MNHP Referral':this.dataLinkId=17;
//       console.log(this.dataLinkId)
//       break;

//       case'HS Raw Data':this.dataLinkId=10;
//       console.log(this.dataLinkId)
//       break;

//       case'All Imported Hearing Screening':this.dataLinkId=49;
//       console.log(this.dataLinkId)
//       break;

//       case'Bloodspot': this.dataLinkId=5;
//       console.log(this.dataLinkId)
//       break;

//       case'Hearing Screening': this.dataLinkId=6;
//       console.log(this.dataLinkId)
//       break;

//       case'AudioLogic Data': this.dataLinkId=7;
//       console.log(this.dataLinkId)
//       break;

//       case'Death Certificate-Unlinked Data':this.dataLinkId=33;
//       console.log(this.dataLinkId)
//       break;

//       // case'Discharge BD': this.dataLinkId=20;
//       case'Discharge (Unlinked Data)': this.dataLinkId=27;
//       console.log(this.dataLinkId)
//       break;

//       case'Bloodspot Filter':this.dataLinkId=8;
//       console.log(this.dataLinkId)
//       break;

//       case'No Bloodspot':this.dataLinkId=9;
//       console.log(this.dataLinkId)
//       break;

//       case'Confirmed Cases Bloodspot':this.dataLinkId=35;
//       console.log(this.dataLinkId)
//       break;

//       case'Death Certificate - DRVS':this.dataLinkId=11;
//       console.log(this.dataLinkId)
//       break;

//       case'Hearing Import Report':this.dataLinkId=40;
//       console.log(this.dataLinkId)
//       break;

//       case'Online BD Cases':this.dataLinkId=31;
//       console.log(this.dataLinkId)
//       break;

//       case'No Initial HS':this.dataLinkId=2;
//       console.log(this.dataLinkId)
//       break;

//       case'New Cases':this.dataLinkId=36;
//       console.log(this.dataLinkId)
//       break;

//       case'Pending Cases':this.dataLinkId=37;
//       console.log(this.dataLinkId)
//       break;

//       case'My Completed Cases':this.dataLinkId=38;
//       console.log(this.dataLinkId)
//       break;

//       case'Triage Log':this.dataLinkId=15;
//       console.log(this.dataLinkId)
//       break;

//       case'Triage Ruled Out':this.dataLinkId=52;
//       console.log(this.dataLinkId)
//       break;

//       case'Triage Assigned':this.dataLinkId=53;
//       console.log(this.dataLinkId)
//       break;

//       case'Discharge-No Case':this.dataLinkId=50;
//       console.log(this.dataLinkId)
//       break;

//       case'Discharge Marked Case':this.dataLinkId=51;
//       console.log(this.dataLinkId)
//       break;

//       // case'Birth Certificate':this.dataLinkId=12;
//       // console.log(this.dataLinkId)
//       // break;

//       case'Discharge':this.dataLinkId=13;
//       console.log(this.dataLinkId)
//       break;


//       // case'Triage Assignments': this.dataLinkId=43;
//       // console.log(this.dataLinkId)
//       // break;
//       case'AD Aggregate': this.dataLinkId=16;
//  console.log(this.dataLinkId)
//  break;

//  case'AD Result': this.dataLinkId=4;
//  console.log(this.dataLinkId)
// break;

//  case'Aggregate Hospital': this.dataLinkId=43;
// console.log(this.dataLinkId)
// break;

//  case'BD Online Report': this.dataLinkId=23;
// console.log(this.dataLinkId)
// break;

//  case'HS Referred Children': this.dataLinkId=3;
//  console.log(this.dataLinkId)
// break;

// case'Passed Rescreens': this.dataLinkId=39;
// console.log(this.dataLinkId)
// break;

//     }
// console.log(this.dataLinkId)
// if(this.dataLinkId!=null)
// {
//  this.httpClient.get(environment.apiURL+"query/actions/"+this.dataLinkId).subscribe(
//  (data:any)=>{
// this.details=data

//  error => console.log('oops', error)
// console.log(this.details)
//  if(this.dataLinkId==15 ||this.dataLinkId==52 ||this.dataLinkId==53 )
// {

// this.details.push({actionType: 'Open Person', columnName: 't.personid', entityName: 'Person'})
//  }
//  }
//  )

//   this.httpClient.get(environment.apiURL+"query/editable_fields/"+this.dataLinkId,httpOptions)
//   .subscribe(
//     (data:any)=>{
//       this.editable_fields=data
//       ,
//       error => console.log('oops', error)
//       console.log(this.editable_fields)
//     }
//   )

// }
//     // try{
//     // }
//     // catch(Exception:any){
//     //   console.log("no data related to it")
//     // }

//   }


 // this function helps in getting all the mapped worbooks based on user
//   getworbooksData() {
// // console.log("in workbook")
//       this.httpClient.get(environment.JavaUrlEndPoint + "getworkbooks").subscribe(
//         (data: any) => {
//           this.workbooksList = data;
//           this.workbookdata=data;
//           console.log(this.workbookdata)

// this.ConfigReports=data.filter(({ configurable }) => configurable == false)

// // this.getTotalWorkbookimages()

//         }
//       );


//   }

  // getTotalWorkbookimages() {
  //   // console.log("in thumbnails")
  //   for (let i = 0; i < this.workbooksList.length; i++) {

  //     const params = new HttpParams()
  //        .set('workbookid', this.workbooksList[i].workbookid)
  //     this.httpClient.get(environment.JavaUrlEndPoint + "getThumbnails", { params: params, responseType: 'blob' }).subscribe(
  //       data => {
  //         const blob = new Blob([data], { type: 'application/jpg' });
  //         this.imagePath = this.sanitizer.bypassSecurityTrustResourceUrl(
  //           window.URL.createObjectURL(data));
  //         this.workbook_images[i] = this.imagePath;

  //       }
  //     )
  //   }

  // }

  // this function helps in geting the trending reports id's based on users
//   gettrendingreports() {

//       this.httpClient.get(environment.JavaUrlEndPoint + "gettrendingreports").subscribe(
//         (data: any) => {
//           // console.log(data)
//           this.trendingList = data;

//         }
//       );

// }

  // this helps in geting new reports id's based on user
  // getnewreports() {

  //     this.httpClient.get(environment.JavaUrlEndPoint + "getnewreports").subscribe(
  //       (data: any) => {
  //         this.newreportslist = data;
  //         // console.log(this.newreportslist)
  //         // this.getTotalWorkbookimages()
  //       }
  //     );

  // }

  // this function helps in geting favourite reports id's based on user
  // getfavreports() {

  //       this.httpClient.get(environment.JavaUrlEndPoint + "getfav").subscribe(
  //         (data: any) => {
  //           // console.log("fav",data)
  //           this.favreports = data;
  //           data=[...data].sort((a,b)=>a.workbookname>b.workbookname?1:-1)
  //           this.favsortingarray=data;
  //           // console.log(this.favsortingarray)
  //         }
  //       );
  // }


  // this function helps in getting the view later id's based on user
  // getwtlreports() {

  //       //for admin
  //       this.httpClient.get(environment.JavaUrlEndPoint + "getwtl").subscribe(
  //         (data: any) => {
  //           this.wtlreports = null;
  //           this.sortwtlreports=null;
  //           this.wtlreports = data;
  //           data=[...data].sort((a,b)=>a.workbookname>b.workbookname?1:-1)
  //           this.sortwtlreports=data;
  //           // console.log(this.wtlreports);
  //         }
  //       );


  // }

  // this function helps in getting the recently viewed id's based on user
  // getrcvreports() {

  //       this.httpClient.get(environment.JavaUrlEndPoint + "getrcv").subscribe(
  //         (data: any) => {
  //           this.rcvreports=null;
  //           this.sortrcvreports=null;
  //           this.rcvreports = data;
  //           data=[...data].sort((a,b)=>a.workbookname>b.workbookname?1:-1)
  //           this.sortrcvreports=data;
  //           // console.log(this.rcvreports)
  //           this.rcvupdated = this.rcvupdated + 1;
  //         }
  //       );

  // }



  // updateDownloadCount(wbid:any)
  // {
  //   console.log(wbid)
  //     const formData: FormData = new FormData();
  //   formData.append('wbid', wbid);
  //     this.httpClient.put(environment.JavaUrlEndPoint + "downloadcount/"+wbid,{ responseType: 'text' as 'json' }).subscribe(
  //       (data: any) => {

  //       });


  // }
  // this function helps in updating report to favourites, view later and rcently viewed based on user
//   updatetreport(wbid: any, type: any, bool: any) {

// // console.log(wbid +''+type+''+bool)
//       this.httpClient.put(environment.JavaUrlEndPoint + "updatefavrcvwtl", {'workbookid':wbid,'type':type,'bool':bool}).subscribe(
//         (data: any) => {
//           if (type == 'fav') {
//             // console.log(wbid,type,bool)
//             // console.log("in fav")
//             this.getfavreports();
//           }
//           else if (type == 'wtl') {
//             this.getwtlreports();
//           }
//           else if (type == 'rcv') {
//             this.getrcvreports();
//           }
//         }
//       );

//   }

  // System admin can perform category CRUD operations
  // this funtion helps admin to add now category
  // createcid(Cwbid: any, Categoryname: any, selectedFile: File) {
  //   const formData: FormData = new FormData();
  //   formData.append('adminid', this.curentuser);
  //   formData.append('category', Categoryname);
  //   if (selectedFile) {
  //     formData.append('imageFile', selectedFile);
  //   }
  //   else {
  //     formData.append('imageFile', "../../../assets/images/Folder-icon.png");
  //   }
  //   if (Cwbid == null) {
  //     Cwbid = 0;
  //     formData.append('Cwbid', Cwbid);
  //   }
  //   else {
  //     formData.append('Cwbid', Cwbid);
  //   }
  //   return this.httpClient.post(environment.JavaUrlEndPoint + 'admin/CreateNewCategory', formData,{ responseType: 'text' as 'json' }).subscribe(
  //     (data: any) => {
  //       this.getmapingFactData();
  //     }
  //   );
  // }

  // this funtion helps admin to add workbook to any category
  // createwbid(Cwbid: any, wbid: any) {
  //   const formData: FormData = new FormData();
  //   formData.append('Cwbid', Cwbid);
  //   formData.append('adminid', this.curentuser);
  //   formData.append('wbid', wbid);
  //   return this.httpClient.post(environment.JavaUrlEndPoint + 'admin/CreateNewReport', formData, { responseType: 'text' as 'json' }).subscribe(
  //     (data: any) => {
  //       this.getmapingFactData();
  //     }
  //   );
  // }

  // this funtion helps admin to edit the category names
  // editCategoryname(Categoryname: any, Cwid: any, selectedFile: any) {
  //   const formData: FormData = new FormData();
  //   formData.append('category', Categoryname);
  //   formData.append('adminid', this.curentuser);
  //   formData.append('cwid', Cwid);
  //   formData.append('imageFile', selectedFile);
  //   return this.httpClient.put(environment.JavaUrlEndPoint + 'admin/editNewCategory', formData, { observe: 'response' }).subscribe(
  //     (data: any) => {
  //       this.getmapingFactData();
  //     }
  //   );
  // }

  // this funtino helps admin to delete any category and any level
  // deletecategory(cwid: any,) {
  //   const params = new HttpParams()
  //     .set('cwid', cwid)

  //   return this.httpClient.delete(environment.JavaUrlEndPoint + 'admin/deleteCategories', { params: params }).subscribe(
  //     (data: any) => {
  //       this.getmapingFactData();
  //     }
  //   );
  // }

  // this funtion helps admin to delete workbook from any category
  // deleteworkbook(cwid: any,) {

  //   const params = new HttpParams()
  //     .set('cwid', cwid)

  //   return this.httpClient.delete(environment.JavaUrlEndPoint + 'admin/deleteWorkbook', { params: params }).subscribe(
  //     (data: any) => {
  //       this.getmapingFactData()
  //     }
  //   );
  // }

  // getunmappedWorkbooks() {
  //   this.httpClient.get(environment.JavaUrlEndPoint + "Admin/unmapped").subscribe(
  //     (data: any) => {
  //       this.unmappedworkbooks = data;
  //     }
  //   );
  // }

  // getFaq() {
  //   return this.httpClient.get(environment.JavaUrlEndPoint + "getAllFaq");
  // }

//   updateUserDetails(formVaruser:any){
//   // console.log(formVaruser);
//   return this.httpClient.put(environment.JavaUrlEndPoint+'admin/updateUserWithRole/'+this.roletypeid, formVaruser).subscribe(
//     (data:any)=>{
//                if(data==true)
//                {
//                 this.getUsers();
//                }
//                else {
//                 window.alert("cannot update atleast one sysadmin should be present")
//                }
//     }
//   );
// }


          // Getroletype()
          // {
          //   this.httpClient.get(environment.JavaUrlEndPoint + 'getAllRoles').subscribe(
          //     (data: any) => {
          //       // console.log("hello"+data)
          //       this.roletypeModel = data;

          //       // console.log(this.roletypeModel);
          //     }
          //     );
          // }
        //   registerUser(formVar:FormGroup){
        //     return this.httpClient.post(environment.JavaUrlEndPoint+'registerUser',formVar,{  responseType: 'text'}
        //     )
        //   }
        //   updateGroupDetails(formVargroup:any)
        //   {
        //         return this.httpClient.put(environment.JavaUrlEndPoint+'admin/updateGroupDetails/'+this.roletypeid, formVargroup).subscribe(
        //           (data:any)=>{
        //                      if(data==true)
        //                      {
        //                       this.getGroups();
        //                      }
        //                      else {
        //                      }
        //           }
        //         );
        //   }
        //   updateRoleDetails(formVarrole:any) {
        //   return this.httpClient.put(environment.JavaUrlEndPoint+'admin/updateRoleFactRoleId/'+this.curentuser,formVarrole )
        // }
        // completestatus(status:any)
        // {
        //   return this.httpClient.put(environment.JavaUrlEndPoint+'Admin/completestatus',status,{  responseType: 'text'} ).subscribe((data:any)=>
        //   {

        //   })

        // }
//         groupList:any[]=[];
//     getGroups(){
//         return this.httpClient.get(environment.JavaUrlEndPoint + 'admin/getGroupsList')
//         .subscribe(
//           (data: any) => {
//             this.groupList=[...data].sort((a,b)=>a.id-b.id)
//             if(this.roletypeid!='1')
//             {
//               this.groupList=[...this.groupList].filter((x: {id: number; })=>x.id!=1)
//             }
//           }
//           );
//         }

//         userprofile:any;
// getUsers(){
//     return this.httpClient.get(environment.JavaUrlEndPoint + 'admin/getAllUserswithRoles').subscribe(
//     (data: any) => {

//       this.UserList=[...data].sort((a,b)=>a.id-b.id);
//       this.userprofile=this.UserList.filter(x=>x.id==localStorage.getItem('currentUser'));
//     }
//     );
//   }
//   AllUsersforUsername:any[]=[]
//   getIfUserExistOrNot()
//   {
//     this.httpClient.get(environment.JavaUrlEndPoint + "getIfUserExistOrNot").subscribe(
//       (data: any) => {
//         this.AllUsersforUsername = data;
//       }
//     );
//   }

//   AllUsersforEmail:any[]=[]
//   getIfEmailExistOrNot()
//   {
//     this.httpClient.get(environment.JavaUrlEndPoint + "getIfEmailExistOrNot").subscribe(
//       (data: any) => {
//         this.AllUsersforEmail = data;
//       }
//     );
//   }

  private httpHeaders = new HttpHeaders({
      'Content-Type': 'multipart/form-data', 'Cache-Control': 'no-cache', 'Pragma': 'no-cache'
  });

  // saveUser(formVar:any)
  // {

  //   this.httpClient.post(environment.JavaUrlEndPoint+"admin/permissions/saveUser/"+this.curentuser,formVar).subscribe(
  //     (data:any)=>
  //     {
  //       this.getUsers();
  //     }
  //   );
  // }

  // saveGroup(group: any) {
  //   return this.httpClient.post(environment.JavaUrlEndPoint+"admin/saveGroup/"+this.curentuser,group).subscribe(
  //       (data:any)=>
  //       {
  //         this.getGroups();
  //       }
  //     );
  // }
}
